import * as React from "react";
import ModalRegistrazione from "@src/components/frontend/modals/ModalRegistrazione";
import FormSelect from "@src/components/ui/FormSelect";
import FormCheckBox from "@src/components/ui/FormCheckBox";

interface Props {
    header: string,
    subjects: string,
    onSave?: any,
    onCancel?: any
}

interface State {
    _modal_materia_elementari: boolean,
    _modal_materia_medie: boolean,
    _modal_materia_superiori: boolean,
    _modal_materia_universita: boolean,
    _modal_materia_extra: boolean,
    _modal_materia_scuole_cond: boolean,
    _modal_materia: string
}

export default class ModalMateria extends React.Component<Props, State> {
    handleChange(field, value) {
        this.setState({
            [field]: value
        });
    }

    formatScuola() {
        let base = "(";

        if(this.state._modal_materia_elementari)
            base += ' Elementari ';
        if(this.state._modal_materia_medie)
            base += ' Medie ';
        if(this.state._modal_materia_superiori)
            base += ' Superiori ';
        if(this.state._modal_materia_universita)
            base += ' Università ';
        if(this.state._modal_materia_extra)
            base += ' Extra ';

        return base += ")"
    }

    onSave() {

        let scuole_cond = {
           elementari: (this.state._modal_materia_elementari) ? 1 : 0,
           medie: (this.state._modal_materia_medie) ? 1 : 0,
           superiori: (this.state._modal_materia_superiori) ? 1 : 0,
           universita: (this.state._modal_materia_universita) ? 1 : 0,
           extra: (this.state._modal_materia_extra) ? 1 : 0,
        };

        console.log('scuole_cond', scuole_cond);

        let result = {
            materia: (this.state && this.state.hasOwnProperty('_modal_materia')) ? this.state._modal_materia : undefined,
            scuole: (this.state && this.state.hasOwnProperty('_modal_materia')) ? this.formatScuola() : undefined,
            scuole_cond,
        };

        console.log('result before', result);
        if(result.materia === undefined || result.materia === '' || result.scuole === undefined || result.scuole === '' || result.scuole === '()') {
            alert('Inserire correttamente materia e livello');
            return;
        }

        const choosenMateria = this.props.items.filter((item) => item.key == result.materia );

        result.name = choosenMateria[0].value;

        console.log('result', result);

        if(this.props.onSave)
            this.props.onSave(result);
    }

    mapListCheckBox(item) {
        return (
            <div className={"col-sm-4"} key={item.key}>
                <FormCheckBox name={item.name} onChange={this.handleChange.bind(this)}>{ item.value }</FormCheckBox>
            </div>
        );
    }

    render() {
        let items = [
            {
                key: "elementari",
                name: "_modal_materia_elementari",
                value: "Elementari"
            },
            {
                key: "medie",
                name: "_modal_materia_medie",
                value: "Medie"
            },
            {
                key: "superiori",
                name: "_modal_materia_superiori",
                value: "Superiori"
            },
            {
                key: "università",
                name: "_modal_materia_universita",
                value: "Università"
            },
            {
                key: "extra",
                name: "_modal_materia_extra",
                value: "Extra"
            }
        ];

        return (
            <ModalRegistrazione header={this.props.header} onSave={this.onSave.bind(this)} onCancel={this.props.onCancel}>
                <div className={"block-simple"}>
                    <span>AGGIUNTA MATERIE</span>
                    <div className={"answer"} style={{maxWidth: "300px"}}>
                        <FormSelect values={this.props.items} placeholder={"Selezionare"} name={"_modal_materia"} onChange={this.handleChange.bind(this)} />
                    </div>
                </div>
                <div className={"block-simple"}>
                    <span>LIVELLO</span>
                    <div className={"answer"}>
                        <div className={"row"}>
                        { items.map(this.mapListCheckBox.bind(this)) }
                        </div>
                    </div>
                </div>
            </ModalRegistrazione>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/ModalMateria.tsx